<template>
    <!-- Modal Detail Peserta RPL -->
    <CModal
        title="Detail Peserta RPL"
        :show.sync="modalDetail"
        :no-close-on-backdrop="true"
        :centered="true"
    >
        <template #header>
            <h6 class="modal-title h5 font-weight-bold">Detail Peserta RPL</h6>
        </template>
        <CRow>
            <div class="modal-body row my-n3">
                <div class="col-5">
                    <p class="font-weight-bold">Nama Anggota</p>
                    <p class="font-weight-bold">Kategori Anggota</p>
                    <p class="font-weight-bold">No. Handphone</p>
                    <p class="font-weight-bold">No. Telepon</p>
                    <p class="font-weight-bold">Email</p>
                </div>
                <div class="col-7">
                    <p>: {{ formData.nama_lengkap ? formData.nama_lengkap : ' - ' }}</p>
                    <p>: {{ showKategori(formData) }}</p>
                    <p>: {{ formData.no_handphone ? formData.no_handphone : ' - ' }}</p>
                    <p>: {{ formData.no_telephone ? formData.no_telephone : ' - ' }}</p>
                    <p>: {{ formData.email ? formData.email : ' - ' }}</p>
                </div>
            </div>
        </CRow>
        <template #footer>
            <router-link :to="`/keanggotaan/data-anggota/data-diri/${formData.id_user}`">
                <CButton color="info">Detail</CButton>
            </router-link>
            <CButton @click="modalDetail = false" color="danger">Tutup</CButton>
        </template>
    </CModal>
    <!-- Modal Detail Peserta RPL -->
</template>

<script>
export default {

    name: 'modal-detail-peserta-rpl',

    props: [
        'modalDetail',        
        'formData',
        'title'
    ],

    watch: {
        modalDetail: function(val) {
            if(!this.modalDetail) {                
                this.$emit('closeModalDetail', val)
            }            
        }
    },
    methods : {
        showKategori(formData) {
            if(formData.kategori_anggota) {
                return formData.kategori_anggota
            } else {
                if(formData.nama_kategori) {
                    return formData.nama_kategori;
                } else {
                    return "-"
                }
            }
        }
    }

}
</script>

<style>

</style>